import type { FC } from 'react';
import { useLngMarketingRoot } from 'src/apis/lng-marketing/use-lng-marketing-root';
import { PageSpinner } from 'src/components/spinner-container';
import { LngAllocationsForOperators } from 'src/pages/lng/allocations/overview/for-operators';
import { LngAllocationsForShippers } from 'src/pages/lng/allocations/overview/for-shippers';
import { Forbidden } from 'src/utils/errors';

export const LngAllocations: FC = () => {
  const lngMarketingRoot = useLngMarketingRoot();

  if (!lngMarketingRoot.response) {
    return <PageSpinner />;
  }

  const isLso =
    lngMarketingRoot.response.data._links.getAllocationsOverviewForLso;
  const isShipper =
    lngMarketingRoot.response.data._links.getAllocationsOverviewForShipper;

  // if organisation has both roles, we preffer LSO to be shown
  if (isLso) {
    return <LngAllocationsForOperators lngMarketingRoot={lngMarketingRoot} />;
  } else if (isShipper) {
    return <LngAllocationsForShippers lngMarketingRoot={lngMarketingRoot} />;
  } else {
    throw new Forbidden();
  }
};
